import { render, staticRenderFns } from "./CaixasOffline.vue?vue&type=template&id=3fe0909f&scoped=true&"
import script from "./CaixasOffline.vue?vue&type=script&lang=js&"
export * from "./CaixasOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe0909f",
  null
  
)

export default component.exports